<div class="preloader">
	<img src="./assets/image/landing/preloader.svg" alt="Pre-loader">
</div>

<!-- =======================
	header Start-->
<header class="navbar-transparent navbar-sticky navbar-primary">
	<!-- Search -->
	<div class="top-search collapse bg-light" id="search-open" data-parent="#search">
		<div class="container">
			<div class="row position-relative">
				<div class="col-md-8 mx-auto py-5">
					<form>
						<div class="input-group">
							<input class="form-control border-radius-right-0 border-right-0" type="text" name="search"
								autofocus placeholder="What are you looking for?">
							<button type="button" class="btn btn-grad border-radius-left-0 mb-0">Search</button>
						</div>
					</form>
					<p class="small mt-2 mb-0"><strong>e.g.</strong>Data, Engine, Algorithm, Solution </p>
				</div>
				<a class="position-absolute top-0 right-0 mt-3 mr-3" data-toggle="collapse" href="#search-open"><i
						class="fa fa-window-close"></i></a>
			</div>
		</div>
	</div>
	<!-- End Search -->

	<!-- Logo Nav Start -->
	<nav class="navbar navbar-expand-lg">
		<div class="container">
			<!-- Logo -->
			<a class="navbar-brand" href="index.html">
				<!-- SVG Logo Start -->
				<img src="./assets/image/logo/dp_logo.png">
				<!-- SVG Logo End -->
			</a>
			<!-- Menu opener button -->
			<button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarCollapse"
				aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"> </span>
			</button>
			<!-- Main Menu Start -->
			<div class="collapse navbar-collapse" id="navbarCollapse">
				<ul class="navbar-nav ml-auto">

					<!-- Menu item 4 Portfolio-->
					<li class="nav-item">
						<a class="nav-link" id="portfolioMenu" href="/portfolio">Portfolio</a>
					</li>
				</ul>
			</div>
			<!-- Main Menu End -->
			<!-- Header Extras Start-->
			<div class="navbar-nav">
				<!-- extra item Search-->
				<div class="nav-item search border-0 pl-3 pr-0 px-lg-2" id="search">
					<a class="nav-link" data-toggle="collapse" href="#search-open"><i class="ti-search"> </i></a>
				</div>
				<!-- extra item Btn-->
				<div class="nav-item border-0 d-none d-lg-inline-block align-self-center mr-3">
					<a routerLink="/home" class="btn btn-sm btn-white mb-0">Dashboard</a>
				</div>
				<div class="nav-item border-0 d-none d-lg-inline-block align-self-center">
					<a routerLink="/register" class="btn btn-sm btn-white mb-0">Sign-up</a>
				</div>
			</div>
			<!-- Header Extras End-->
		</div>
	</nav>
	<!-- Logo Nav End -->
</header>
<!-- =======================
	header End-->

<!-- =======================
	Main Banner -->
<section class="p-0 py-5 bg-grad pattern-overlay-2">
	<div class="container">
		<div class="row py-0 py-md-5 justify-content-between align-items-center">
			<div class="col-sm-10 col-lg-6 all-text-white my-5 mt-md-0">
				<div class="text-left py-0 py-md-5 my-5">
					<h6>Unlock your value of Data today!!</h6>
					<h2 class="display-5 display-lg-4 font-weight-normal cd-headline clip big-clip is-full-width">The
						Powerhouse of Data
						<span class="cd-words-wrapper pt-0">
							<b class="is-hidden">Socialization</b>
							<b class="is-visible">Monetization</b>
							<b class="is-hidden">Fabric</b>
						</span>
					</h2>
					<p class="mb-4 display-8 font-weight-normal">An open marketplace to provide every individual,
						enterprise, non-profit organizations & research companies a platform to monetize & exchange data
						in a regulated economy.</p>
					<a routerLink="/home" class="btn btn-white mr-3">Login</a>
				</div>
			</div>
			<div class="col-sm-10 col-md-6 d-none d-lg-block mb-5">
				<img class="rounded shadow" src="./assets/image/blog1.jpg" alt="">
				<div class="pos-absolute-center">
					<a class="btn btn-grad btn-round btn-lg zoom-on-hover" data-fancybox=""
						href="https://youtu.be/o5G73Tgk_TA"> <i class="fa fa-play"></i> </a>
				</div>
			</div>
		</div>
	</div>
	<div class="position-absolute bottom-0 left-0 w-100 d-none d-md-block mb-n3">
		<svg width="100%" height="150" viewBox="0 0 500 150" preserveAspectRatio="none">
			<path d="M0,150 L0,40 Q250,150 500,40 L580,150 Z" fill="white" />
		</svg>
	</div>
</section>
<!-- =======================
	Main banner -->

<!-- =======================
	client -->
<section class="client p-0 mt-5 mt-md-0">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="owl-carousel owl-grab" data-arrow="false" data-dots="false" data-items-xl="6"
					data-items-lg="5" data-items-md="4" data-items-sm="3" data-items-xs="2" data-autoplay="4500">
					<div class="item"><img src="./assets/image/landing/clients/01.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/02.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/03.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/04.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/05.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/06.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/07.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/08.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/09.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/10.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/11.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/12.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/14.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/15.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/16.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/17.png" alt=""></div>
					<div class="item"><img src="./assets/image/landing/clients/18.png" alt=""></div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	client -->

<div class="divider mt-5"></div>

<!-- =======================
	about us  -->
<section>
	<div class="container ">
		<div class="row">
			<div class="col-md-8 mx-auto text-center mb-5">
				<h2 class="h1 font-weight-bold">Blockchain and Artificial Intelligence Powered</h2>
				<h5>At DataPitcher, we transform your assets into a tradeable commodity</h5>
				<p>Source, exchange and monetize data with globally, securely and in full compliance with geographical
					regulations.</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-4">
				<div class="feature-box h-100 text-center px-4 py-5">
					<div class="feature-box-icon"><img class="w-25" src="./assets/image/landing/icons/check-mark.svg"
							alt=""></div>
					<h3 class="feature-box-title">Secured Exchange</h3>
					<p class="feature-box-desc">Blockchain driven secured and trustworthy marketplace to trace data
						sourcing and lifecycle.</p>
				</div>
			</div>
			<div class="col-md-4">
				<div class="feature-box h-100 text-center all-text-white bg-grad px-4 py-5 border-radius-3">
					<div class="feature-box-icon"><img class="w-25" src="./assets/image/landing/icons/editor.svg"
							alt=""></div>
					<h3 class="feature-box-title">Data Valuation</h3>
					<p class="feature-box-desc">“Patent-Pending Data Valuation Software” to provide right value for your
						data and to regulate data economy.</p>
				</div>
			</div>
			<div class="col-md-4">
				<div class="feature-box h-100 text-center px-4 py-5">
					<div class="feature-box-icon"><img class="w-25" src="./assets/image/landing/icons/envelope.svg"
							alt=""></div>
					<h3 class="feature-box-title">Opportunity for Everyone</h3>
					<p class="feature-box-desc">Data Enrichment by extending Platform for everyone to sell data
						derivatives like algorithms, engines & solutions.</p>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	about us  -->

<div class="divider mt-5"></div>

<!-- =======================
	video -->
<section>
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-6 align-self-center ">
				<div class="title text-left">
					<span class="pre-title">DataPitcher Blueprint</span>
					<h2>Reimaging Data Chemistry <span class="text-primary">to create data-driven</span> solutions.</h2>
					<p class="mb-0">Our team of engineers, scientists & economists paired-up with the business
						powerhouses, domain practitioners, industrial experts & research scholars to redefine "Data
						Chemistry" and to recreate Data Atoms, Elements, Molecules & Compounds to accelerate data-driven
						solutions.</p>
				</div>
			</div>
			<div class="col-md-10 col-lg-6 mx-md-auto align-self-center ">
				<div class="ml-4 ml-md-n2 mb-3">
					<video loop autoplay controls>
						<source src="./assets/video/DP.mp4" type="video/mp4">
					</video>
				</div>
			</div>
		</div>
		<!-- row end -->
	</div>
</section>
<!-- =======================
	video -->

<!-- =======================
	about us  -->
<section>
	<div class="container">
		<div class="row justify-content-between align-items-center">
			<!-- left -->
			<div class="col-md-6">
				<div class="row mt-4 mt-md-0">
					<div class="col-5 offset-1 px-2 mb-3 align-self-end">
						<img class="border-radius-3 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s"
							src="./assets/image/people.jpg" alt="">
					</div>
					<div class="col-6 px-2 mb-3">
						<img class="border-radius-3 wow fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.6s"
							src="./assets/image/virtualreality.jpg" alt="">
					</div>
					<div class="col-7 px-2 mb-3">
						<div class="border-radius-3 wow fadeInLeft bg-grad p-2 p-sm-3 p-lg-4 p-xl-5 all-text-white"
							data-wow-duration="0.8s" data-wow-delay="0s">
							<span>Our goal:</span>
							<h3 class="font-weight-bold">"Monetizing Data to empower you"</h3>
						</div>
					</div>
					<div class="col-5 align-self-start pl-2 mb-3">
						<img class="border-radius-3 wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.2s"
							src="./assets/image/workspace2.jpg" alt="">
					</div>
				</div>
			</div>
			<!-- right -->
			<div class="col-md-6 pl-lg-5">
				<h2 class="h1">All industries gain benefits from Data Exchange</h2>
				<p class="lead">Data circulation accelerates companies’ digital transformation.70% of data exchange
					happen between organization <abbr title="title">from different sectors.</abbr></p>
				<p>A wealth of data from thousands of companies in 15+ sectors are available to support your data
					strategy. Source, exchange and monetize data to boost innovation and create value.</p>
				<div>
					<a routerLink="/login" class="btn btn-dark">Login/Signup</a>
					<!--
						<a class="nav-link" id="portfolioMenu" routerLink="/portfolio">Our Product</a>
						-->
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	about us  -->

<!-- =======================
	about us -->
<section class="position-relative bg-light">
	<div class="container">
		<div class="row justify-content-between align-items-center">
			<!-- left -->
			<div class="col-md-6">
				<figure class="w-100 ie-height-600">
					<svg version="1.1" id="about-image" xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 678 595"
						style="enable-background:new 0 0 678 595;" xml:space="preserve">
						<defs>
							<linearGradient id="BgGradient">
								<stop class="fill-grad-start" offset="0%" />
								<stop class="fill-grad-end" offset="100%" />
							</linearGradient>
						</defs>
						<path id="about-image-bg" fill="url(#BgGradient)" d="M652.2,493.6c-51.9,58.8-395.9,51.9-395.9,51.9S7.4,581.8,50.6,396.8
						C82.3,261.5,2.2,56.3,97.3,20c49-18.7,351.7-49,487.8,70.9C713.1,203.4,677.3,465.1,652.2,493.6z" />
						<g id="XMLID_120_">
							<defs>
								<path id="XMLID_7_" d="M635.5,506.9c-51.9,58.8-395.9,51.9-395.9,51.9S-9.3,595,34,410C65.6,274.7-14.4,69.5,80.6,33.2
								c49-18.7,351.7-49,487.8,70.9C696.4,216.7,660.6,478.4,635.5,506.9z" />
							</defs>
							<clipPath id="XMLID_155_">
								<use xlink:href="#XMLID_7_" style="overflow:visible;" />
							</clipPath>
							<g style="clip-path:url(#XMLID_155_);">

								<image style="overflow:visible;" width="700" height="700" id="XMLID_121_"
									xlink:href="./assets/image/groupofpeople.jpg"
									transform="matrix(0.9999 0 0 0.9999 1 -81)">
								</image>
							</g>
						</g>
						<circle fill="none" stroke="url(#BgGradient)" stroke-width="8" stroke-miterlimit="10" cx="60"
							cy="539" r="40" />
						<path id="XMLID_149_" fill="url(#BgGradient)" d="M52.6,104.3L25.5,46.5c-2-4.2-0.1-9.4,4.1-11.3l0,0c4.2-2,9.4-0.1,11.3,4.1L68,97c2,4.2,0.1,9.4-4.1,11.3
								l0,0C59.7,110.4,54.6,108.5,52.6,104.3z" />
						<path id="XMLID_150_" fill="url(#BgGradient)" d="M48.1,140.6l-12.8-27.2c-2-4.2-0.1-9.4,4.1-11.3l0,0c4.2-2,9.4-0.1,11.3,4.1l12.8,27.2
									c2,4.2,0.1,9.4-4.1,11.3l0,0C55.2,146.7,50.1,144.8,48.1,140.6z" />
						<circle id="XMLID_151_" fill="url(#BgGradient)" cx="590.9" cy="23.9" r="9.1" />
						<circle id="XMLID_152_" fill="url(#BgGradient)" cx="596.8" cy="76.4" r="14.6" />
						<circle id="XMLID_153_" fill="url(#BgGradient)" cx="630.8" cy="42.8" r="5.3" />
					</svg>
				</figure>
			</div>
			<!-- right -->
			<div class="col-md-6 mt-4 mt-md-0">
				<h6 class="text-primary">About us</h6>
				<h2 class="h1">Money Making Partner for your digital assets.</h2>
				<p class="lead">We have developed a powerful feature set dedicated to monetizing and acquiring data. A
					trusted place for data suppliers and buyers.</p>
				<p>Data providers and acquirers on a Data Exchange Platform benefit from multiple integrated
					functionalities making data sharing, sourcing and monetizing easy, effective and secure.</p>
				<p><span class="text-dark font-weight-bold">— Gaurav Gupta,</span> Founder & CEO, DataPitcher</p>
				<img class="w-40" src="./assets/image/landing/mockups/Sign Almondita.png" alt="">
			</div>
		</div>
	</div>
	<!-- svg wave top-->
	<figure class="position-absolute top-0 left-0 w-100 d-none d-md-block ie-d-none mt-n3">
		<svg version="1.1" id="wave-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px" y="0px" viewBox="0 0 1920 43.4" style="enable-background:new 0 0 1920 43.4;" xml:space="preserve">
			<path id="wave-1-path" class="fill-light"
				d="M0,23.3c0,0,405.1-43.5,697.6,0c316.5,1.5,108.9-2.6,480.4-14.1c0,0,139-12.2,458.7,14.3 c0,0,67.8,19.2,283.3-22.7v35.1H0V23.3z" />
		</svg>
	</figure>
	<!-- svg wave bottom-->
	<figure class="position-absolute bottom-0 left-0 w-100 d-none d-md-block ie-d-none mb-n3">
		<svg version="1.1" id="wave-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px" y="0px" viewBox="0 0 1920 43.4" style="enable-background:new 0 0 1920 43.4;" xml:space="preserve">
			<path id="wave-2-path_" class="fill-white"
				d="M0,23.3c0,0,405.1-43.5,697.6,0c316.5,1.5,108.9-2.6,480.4-14.1c0,0,139-12.2,458.7,14.3 c0,0,67.8,19.2,283.3-22.7v35.1H0V23.3z" />
		</svg>
	</figure>
</section>
<!-- =======================
	about us -->

<!-- =======================
	service -->
<section class="pb-3">
	<div class="container">
		<div class="row">

			<!-- column 1 -->
			<div class="col-md-4">
				<!-- title -->
				<h5 class="text-primary">Our services</h5>
				<h2 class="h1">Access all the features you need</h2>
				<p>We have developed a powerful feature set dedicated to monetizing and acquiring data. A trusted place
					for data suppliers and buyers.</p>
				<!-- service item -->
				<div class="bg-light p-4 p-lg-5 ">
					<span class="display-5 icon-primary"><i class="ti-ruler-pencil"></i></span>
					<h5>Free or Paid data</h5>
					<p class="mb-0">Take advantage of the flexibility of the DataPitcher platform to monetize your data
						or exchange it free of charge.</p>
				</div>
			</div>

			<!-- column 2 -->
			<div class="col-md-4 mt-5">
				<!-- service item -->
				<div class="bg-light p-4 p-lg-5 mb-5">
					<span class="display-5 icon-primary"><i class="ti-pencil-alt"></i></span>
					<h5>Security, Compliance, and Privacy</h5>
					<p class="mb-0">Data transactions around the world are based on trust. We use the Smart Contract
						technology & regional storage to ensure the integrity of the licensing contract.</p>
				</div>
				<!-- service item -->
				<div class="bg-light p-4 p-lg-5 mb-5">
					<span class="display-5 icon-primary"><i class="ti-image"></i></span>
					<h5>Volume, Variety, and Speed</h5>
					<p class="mb-0">Exchange unlimited amounts of data--most formats are accepted--however frequently
						you decide.</p>
				</div>
			</div>

			<!-- column 3 -->
			<div class="col-md-4">
				<!-- service item -->
				<div class="bg-grad all-text-white p-4 p-lg-5 mb-5">
					<span class="display-5"><i class="ti-world icon-white"></i></span>
					<h5>Unique Data Valuation</h5>
					<p class="mb-0">We provide unique opportunity to every individual and enterprise to earn true value
						of their digital assets.</p>
				</div>
				<!-- service item -->
				<div class="bg-light p-4 p-lg-5 mb-5">
					<span class="display-5 icon-primary"><i class="ti-wallet"></i></span>
					<h5>Highly Scalable & Secure Architecture</h5>
					<p class="mb-0">Our Data Exchange Platform is hosted in the cloud, allowing for maximum flexibility
						to match your specific requirements.</p>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	service -->

<!-- =======================
	counter -->
<section class="p-0 counter counter-small">
	<div class="container">
		<div class="row ">
			<div class="col-md-12">
				<div class="bg-dark border-radius-3 py-5 all-text-white pattern-overlay-2">
					<div class="row">
						<!-- count item -->
						<div class="col-md-3 col-6">
							<div class="counter-item text-center">
								<i class="counter-item-icon ti-write"></i>
								<h2 class="counter-item-digit" data-from="0" data-to="200" data-speed="3000"
									data-refresh-interval="10">200</h2>
								<p class="counter-item-text">Sellers</p>
							</div>
						</div>
						<!-- count item -->
						<div class="col-md-3 col-6">
							<div class="counter-item text-center">
								<i class="counter-item-icon ti-truck"></i>
								<h2 class="counter-item-digit" data-from="0" data-to="80" data-speed="3000"
									data-refresh-interval="10">20</h2>
								<p class="counter-item-text">Domains</p>
							</div>
						</div>
						<!-- count item -->
						<div class="col-md-3 col-6">
							<div class="counter-item text-center">
								<i class="counter-item-icon ti-face-smile"></i>
								<h2 class="counter-item-digit" data-from="0" data-to="10000" data-speed="3000"
									data-refresh-interval="10">10000</h2>
								<p class="counter-item-text">Individuals</p>
							</div>
						</div>
						<!-- count item -->
						<div class="col-md-3 col-6">
							<div class="counter-item text-center">
								<i class="counter-item-icon ti-cup"></i>
								<h2 class="counter-item-digit" data-from="0" data-to="250" data-speed="3000"
									data-refresh-interval="10">250</h2>
								<p class="counter-item-text">Researchers</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	counter -->

<!-- =======================
	Portfolio -->
<section class="portfolio portfolio-style-2 pb-0">
	<div class="container">
		<div class="row">
			<div class="col-12 col-lg-8 mx-auto">
				<div class="title text-center">
					<span class="pre-title">Product Portfolio </span>
					<h2>Checkout our Digital Assets</h2>
					<p class="mb-0">Distribute and access data from any business sector. Everyone can benefit from a
						growth lever derived from circulating data.</p>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12 p-0">
				<div class="portfolio-wrap grid items-3 items-padding"
					data-isotope='{ "itemSelector": ".isotope-item", "layoutMode": "masonry" }'>
					<!-- portfolio-card -->
					<div class="portfolio-card isotope-item digital">
						<div class="portfolio-card-body">
							<div class="portfolio-card-header">
								<img src="./assets/image/health.jpg" alt="">
							</div>
							<div class="portfolio-card-footer">
								<a class="full-screen" href="./assets/image/health.jpg" data-fancybox="portfolio"
									data-caption="Fly in time"><i class="ti-fullscreen"></i></a>
								<h6 class="info-title"><a href="http://www.datapitcher.io/" target="_blank"
										title="">Healthcare & Life Sciences</a></h6>
								<p>X-Rays,CT-Scans,EHR Data:$1-$500</p>
							</div>
						</div>
					</div>
					<!-- portfolio-card -->
					<div class="portfolio-card isotope-item photo">
						<div class="portfolio-card-body">
							<div class="portfolio-card-header">
								<img src="./assets/image/finance.jpeg" alt="">
							</div>
							<div class="portfolio-card-footer">
								<a class="full-screen" href="./assets/image/finance.jpeg" data-fancybox="portfolio"
									data-caption="Waiting window"><i class="ti-fullscreen"></i></a>
								<h6 class="info-title"><a href="#" title="">Bank,Insurance & Financial Services</a></h6>
								<p>Anonymized Financing Data:$1-$100</p>
							</div>
						</div>
					</div>
					<!-- portfolio-card -->
					<div class="portfolio-card isotope-item digital marketing">
						<div class="portfolio-card-body">
							<div class="portfolio-card-header">
								<img src="./assets/image/energy.jpeg" alt="">
							</div>
							<div class="portfolio-card-footer">
								<a class="full-screen" href="./assets/image/energy.jpeg" data-fancybox="portfolio"
									data-caption="Green Book"><i class="ti-fullscreen"></i></a>
								<h6 class="info-title"><a href="#" title="">Environment & Energy</a></h6>
								<p>Utility Bills e.g. Electricity:$0.5-$5</p>
							</div>
						</div>
					</div>
					<!-- portfolio-card -->
					<div class="portfolio-card isotope-item digital">
						<div class="portfolio-card-body">
							<div class="portfolio-card-header">
								<img src="./assets/image/education.jpeg" alt="">
							</div>
							<div class="portfolio-card-footer">
								<a class="full-screen" href="./assets/image/education.jpeg" data-fancybox="portfolio"
									data-caption="Reebok Sneakers"><i class="ti-fullscreen"></i></a>
								<h6 class="info-title"><a href="#" title="">Education & Training</a></h6>
								<p>Student Preferences Data:$1-$50</p>
							</div>
						</div>
					</div>
					<!-- portfolio-card -->
					<div class="portfolio-card isotope-item digital">
						<div class="portfolio-card-body">
							<div class="portfolio-card-header">
								<img src="./assets/image/retail.jpeg" alt="">
							</div>
							<div class="portfolio-card-footer">
								<a class="full-screen" href="./assets/image/retail.jpeg" data-fancybox="portfolio"
									data-caption="Work desk"><i class="ti-fullscreen"></i></a>
								<h6 class="info-title"><a href="#" title="">Retail & Consumer Goods</a></h6>
								<p>Geolocation,E-Commerce Data:$1-$100</p>
							</div>
						</div>
					</div>
					<!-- portfolio-card -->
					<div class="portfolio-card isotope-item photo">
						<div class="portfolio-card-body">
							<div class="portfolio-card-header">
								<img src="./assets/image/power.jpeg" alt="">
							</div>
							<div class="portfolio-card-footer">
								<a class="full-screen" href="./assets/image/power.jpeg" data-fancybox="portfolio"
									data-caption="Green Tree"><i class="ti-fullscreen"></i></a>
								<h6 class="info-title"><a href="https://data.gov.in/" target="_blank" title="">Public
										Sector</a></h6>
								<p>Smart-City,Demographic Data:$5-$250</p>
							</div>
						</div>
					</div>
				</div>
				<!-- portfolio wrap -->
			</div>
		</div>
	</div>
</section>
<!-- =======================
	Portfolio -->

<!-- =======================
	package -->

<section class="package pt-5 pb-0">
	<div class="container" id="purchasecards">
		<div class="menu-wrapper ">
			<ul class="menu disable-scrollbars" style="margin-bottom: 0px;">

				<li class="item">
					<div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)"
						routerLink="/login">
						<div class="card-img-top"
							style="background-image: url(../../../assets/image/testimage_health.jpg);  --my-color-var: linear-gradient(to top, #70e1f5, #ffd194);">
							<img class="premium" src="../../../assets/image/Data.png">
							<div class="card-category">
								<img src="../../../assets/image/healthcare2.png" style="margin-left: 4%;">
								<p>HealthCare</p>
							</div>
						</div>
						<div class="card-body">
							<p><a type="button">Show Details</a></p>
							<span>Healthcare</span>,&nbsp;<span>CT-Scans</span>
							<div class="row title-price">
								<div class="col-sm-8 title">
									<div class="product-title">Full Body CT-Scans with detailed radiologist report for
										350 patients</div>
									<div class='tooltip'>
										Full Body CT-Scans with detailed Radiologist report
									</div>
								</div>
								<div class="col-sm-4 price">
									<h4>$1750</h4>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Confidential.png">
									<p>Confidential</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Raw.png">
									<p>Raw Data</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Data Stamping.png">
									<p>Certified</p>
								</div>
							</div>

						</div>
					</div>

				</li>
				<!--
		-->
				<li class="item">
					<div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)"
						routerLink="/login">
						<div class="card-img-top"
							style="background-image: url(../../../assets/image/testimage_finance.jpg);  --my-color-var: linear-gradient(#fc00ff, #00dbde);">
							<img class="premium" src="../../../assets/image/Data.png">
							<div class="card-category">
								<img src="../../../assets/image/Finance.png">
								<p>Finance</p>
							</div>
						</div>
						<div class="card-body">
							<p><a type="button">Show Details</a></p>
							<span>Finance</span>,&nbsp;<span>Corporate Financing</span>
							<div class="row title-price">
								<div class="col-sm-8 title">
									<div class="product-title">Balance Sheet, Profit Statements of 500 Micro Enterprises
									</div>
									<div class='tooltip'>
										Balance Sheet, Profit Statements of 500 Micro Enterprises
									</div>
								</div>
								<div class="col-sm-4 price">
									<h4>$175</h4>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Sensitive.png">
									<p>Sensitive</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Transformed.png">
									<p>Transformed</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Power_Stamping.png">
									<p>Power Stamping</p>
								</div>
							</div>

						</div>
					</div>
				</li>
				<!--
		-->
				<li class="item">
					<div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)"
						routerLink="/login">
						<div class="card-img-top"
							style="background-image: url(../../../assets/image/testtechnology.jpeg);  --my-color-var: linear-gradient(to bottom, rgba(0,0,0,0), #bb377d);">
							<img class="premium" src="../../../assets/image/Solution.png">
							<div class="card-category">
								<img src="../../../assets/image/technology.png">
								<p>Technology</p>
							</div>
						</div>
						<div class="card-body">
							<p><a type="button">Show Details</a></p>
							<span>Nurse-Rostering</span>,&nbsp;<span>Employee-Shift</span>
							<div class="row title-price">
								<div class="col-sm-8 title">
									<div class="product-title">To solve employee shift rostering challenges for
										Organization</div>
									<div class='tooltip'>
										To solve employee shift rostering challenges for Organization
									</div>
								</div>
								<div class="col-sm-4 price">
									<h4>$150</h4>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Public.png">
									<p>Public</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Raw.png">
									<p>Raw</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Power_Stamping.png">
									<p>Power Stamping</p>
								</div>
							</div>

						</div>
					</div>

				</li>
				<!--
		-->
				<li class="item">
					<div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)"
						routerLink="/login">
						<div class="card-img-top"
							style="background-image: url(../../../assets/image/energy.jpeg);  --my-color-var: linear-gradient(to bottom,#00c9ff, #92fe9d);">
							<img class="premium" src="../../../assets/image/Data.png">
							<div class="card-category">
								<img src="../../../assets/image/Energy.png" style="margin-left: 4%;">
								<p>Energy</p>
							</div>
						</div>
						<div class="card-body">
							<p><a type="button">Show Details</a></p>
							<span>Electricity</span>,&nbsp;<span>Bills</span>
							<div class="row title-price">
								<div class="col-sm-8 title">
									<div class="product-title">Excel containing original electricity usage of 10000
										people </div>
									<div class='tooltip'>
										Excel containing original electricity usage of 10000 people
									</div>
								</div>
								<div class="col-sm-4 price">
									<h4>$100</h4>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Sensitive.png">
									<p>Sensitive</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Transformed.png">
									<p>Transformed</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Data Stamping.png">
									<p>Certified</p>
								</div>
							</div>

						</div>
					</div>

				</li>
				<!--
		-->
				<li class="item" style="margin-right: 20px;">
					<div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)"
						routerLink="/login">
						<div class="card-img-top"
							style="background-image: url(../../../assets/image/testimage_realestate.jpg); --my-color-var: linear-gradient(to bottom,rgba(0,0,0,0),#ff5433 100%);">
							<img class="premium" src="../../../assets/image/Algorithm.png">
							<div class="card-category">
								<img src="../../../assets/image/Real Estate.png" style="margin-left: 4%;">
								<p>Real Estate</p>
							</div>
						</div>
						<div class="card-body">
							<p><a type="button">Show Details</a></p>
							<span>House</span>,&nbsp;<span>Prediction</span>
							<div class="row title-price">
								<div class="col-sm-8 title">
									<div class="product-title">House Prediction Classfication Model for an area </div>
									<div class='tooltip'>
										House Prediction Classfication Model for an area
									</div>
								</div>
								<div class="col-sm-4 price">
									<h4>$400</h4>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Confidential.png">
									<p>Confidential</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Transformed.png">
									<p>Transformed</p>
								</div>
								<div class="col-sm-4 info-row">
									<img src="../../../assets/image/Data Stamping.png">
									<p>Certified</p>
								</div>
							</div>

						</div>
					</div>

				</li>
			</ul>

			<div class="paddles">

				<img class="left-paddle paddle" src="../../../assets/image/return.png">

				<img class="right-paddle paddle " src="../../../assets/image/right-arrow.png">
			</div>

		</div>

	</div>
</section>


<section class="package pt-5 pb-0">
	<div class="container">
		<div class="row">
			<div class="col-md-7">
				<div class="title text-left">
					<span class="pre-title">Subscription Plans</span>
					<h2>Start your journey with Free Trial</h2>
					<p>Access the marketplace to monetize or acquire your data from around the entire world. Or use our
						technology for Storage Management, Personlization, Virtual & Private discussions, ML &
						Analytics.</p>
					<p>Choose the most appropriate offering to join the data marketplace.</p>
				</div>
				<!-- price tab nav -->
				<ul class="nav nav-tabs tab-grad">
					<li class="nav-item"> <a class="nav-link active" data-toggle="tab" href="#price-1-tab"> Enterprise
						</a> </li>
					<li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#price-2-tab"> Business </a> </li>
				</ul>
				<!-- price tab end-->
			</div>
			<div class="col-md-5 mt-4 mt-md-0">
				<div class="tab-content p-0">
					<!-- tab 1 (price 1) -->
					<div class="tab-pane show active" id="price-1-tab">
						<div class="card">
							<div class="card-header text-white bg-grad">
								<div class="float-left">
									<h2 class="text-white font-weight-bold mb-0 display-4"><span>$</span>549.99</h2>
									<div>Per Month</div>
								</div>
							</div>
							<div class="card-body bg-light ">
								<ul class="list-group list-group-borderless my-3">
									<li class="list-group-item"><i class="fa fa-check"></i>Unlimited Data Offerings</li>
									<li class="list-group-item"><i class="fa fa-check"></i>Free Data Exchange</li>
									<li class="list-group-item"><i class="fa fa-check"></i>Free Data Anonymization &
										Data Stamping</li>
									<li class="list-group-item"><i class="fa fa-check"></i>1000GB Storage Included</li>
									<li class="list-group-item"><i class="fa fa-check"></i>$500 - Data/ML Services
										Credits</li>
								</ul>
								<a class="btn btn-grad" routerLink="/login">Get it now!</a>
								<div class="offer">-40%</div>
							</div>
						</div>
					</div>
					<!-- tab 2 (price 2) -->
					<div class="tab-pane" id="price-2-tab">
						<div class="card">
							<div class="card-header text-white bg-grad">
								<div class="float-left">
									<h2 class="text-white font-weight-bold mb-0 display-4"><span>$</span>249.99</h2>
									<div>Per Month</div>
								</div>
							</div>
							<div class="card-body bg-light ">
								<ul class="list-group list-group-borderless my-3">
									<li class="list-group-item"><i class="fa fa-check"></i>10 Data Offerings</li>
									<li class="list-group-item"><i class="fa fa-check"></i>Free Data Exchange</li>
									<li class="list-group-item"><i class="fa fa-check"></i>Free Quality Evaluation</li>
									<li class="list-group-item"><i class="fa fa-check"></i>250GB Storage Included</li>
									<li class="list-group-item"><i class="fa fa-check"></i>$100 - Data/ML Services
										Credits</li>
								</ul>
								<a class="btn btn-grad" href="#!">Get it now!</a>
								<div class="offer">-25%</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	package -->

<!-- =======================
	features  -->
<section>
	<div class="container">
		<div class="row no-gutters justify-content-between align-items-center">
			<!-- left -->
			<div class="col-md-6">
				<h2 class="h1 font-weight-bold">Incubated by TBDC,Canada</h2>
				<h5>Toronto Business Development Centre is mentoring us to launch, grow & scale as platform with
					different stakeholders.</h5>
				<p>Our Platform & Architecture has been evaluated by experts on the ground of Data Security, Privacy &
					Compliance.</p>
				<p>We have been rated as one of the fastest growing digital transformation company by data experts,
					machine learning practitioners & business powerhouses.</p>
				<div class="skill skill-text-in skill-grad my-4">
					<div class="skill-wrap">
						<!-- Skill item -->
						<div class="skill-item">
							<p>Expert Reviews</p>
							<div class="progress">
								<div class="progress-bar wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".5s"
									role="progressbar" aria-valuenow="98" aria-valuemin="0" aria-valuemax="100"
									style="width:85%"><span class="skill-percent">98%</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<a href="https://tbdc.com/" target="blank" class="btn btn-dark text-left mb-md-0 mb-2 ">
					<img src="./assets/image/icons/toronto.png" width="150">
				</a>
			</div>
			<!-- right -->
			<div class="col-md-6">
				<img src="./assets/image/landing/mockups/fly-screen.png" alt="">
			</div>
		</div>
	</div>
</section>
<!-- =======================
	features  -->

<!-- =======================
	testimonial -->
<section class="parallax-bg bg-overlay-dark-2"
	style="background:url(./assets/image/gps.jpg) no-repeat center center; background-size:cover;">
	<div class="container">
		<div class="row">
			<!-- left -->
			<div class="col-md-7 col-lg-6">
				<div class="z-index-9 testimonials all-text-white bg-grad p-3 p-sm-5 border-radius-3">
					<span><i class="fa fa-quote-left display-6 mb-3"></i></span>
					<!-- owl-carousel start-->
					<div class="owl-carousel testi-full dots-white dots-right-top owl-grab" data-arrow="false"
						data-items="1" data-autoplay="4500">
						<!-- testimonial item -->
						<div class="item">
							<div class="testimonials-wrap">
								<div class="testi-text text-left p-0">
									<p class="text-white">Data Exchange with other Diagnostic Centres has helped us to
										accelerate innovative medical solutions like Breast Cancer prediction for
										patients.</p>
									<div class="media align-items-center">
										<div class="testi-avatar mb-0"> <img class="w-75"
												src="./assets/image/landing/thumbnails/avatar-01.jpg" alt="avatar">
										</div>
										<div>
											<h6 class="m-0">Prashant Gupta</h6>
											<h6 class="small">Executive Director, Sharda Hospital</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- testimonial item -->
						<div class="item">
							<div class="testimonials-wrap">
								<div class="testi-text text-left p-0">
									<p class="text-white">Exchange of corporate financing data like balance sheets,
										invoices helped us to create our own home-grown micro-financing system.</p>
									<div class="media align-items-center">
										<div class="testi-avatar mb-0"> <img class="w-75"
												src="./assets/image/landing/thumbnails/avatar-02.jpg" alt="avatar">
										</div>
										<div>
											<h6 class="m-0">Tripti Somani</h6>
											<h6 class="small">CEO, KGS Advisors</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="item">
							<div class="testimonials-wrap">
								<div class="testi-text text-left p-0">
									<p class="text-white">DataPitcher helped us to provide secured storage for our
										jewellery customers apart from personalized analytics.</p>
									<div class="media align-items-center">
										<div class="testi-avatar mb-0"> <img class="w-75"
												src="./assets/image/landing/thumbnails/avatar-03.jpg" alt="avatar">
										</div>
										<div>
											<h6 class="m-0">Pragya Somani</h6>
											<h6 class="small">Co-Partner, A.P. Mangatram Enterprise</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- owl-carousel End-->
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	testimonial -->

<!-- =======================
	team grid -->
<section class="team team-grid">
	<div class="container">
		<div class="row">
			<div class="col-12 col-lg-8 mx-auto">
				<div class="title text-center">
					<span class="pre-title">Leadership Team</span>
					<h2>Empowering Digital Transformation</h2>
					<p>Our team consists of domain practitioners, technical experts, business powerhouses, research
						scholars and economists.</p>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<div class="owl-carousel owl-grab dots-primary" data-arrow="false" data-dots="true" data-items-xl="2"
					data-items-xs="1" data-autoplay="4500">
					<!-- Team item -->
					<div class="item">
						<div class="team-item">
							<div class="team-avatar">
								<img class="rounded" src="./assets/image/professional_user1.jpg" alt="">
							</div>
							<div class="team-desc">
								<h4 class="team-name">Gaurav Gupta</h4>
								<span class="team-position">Founder & CEO</span>
								<p>Over 15+ years of application development experience in areas of Blockchain, Machine
									Learning & Quantitative Algorithms. TEDx Speaker in area of Cognitive Neuroscience &
									holder of 4 USA Approved Patents. Worked with companies like Microsoft, Adobe as
									Senior Computer Scientist.</p>
								<ul class="social-icons light si-colored-bg-on-hover no-pb">
									<li class="social-icons-item social-linkedin"><a class="social-icons-link"
											href="https://www.linkedin.com/in/gauravright85/" target="_blank"><i
												class="fa fa-linkedin"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
					<!-- Team item -->
					<div class="item">
						<div class="team-item">
							<div class="team-avatar">
								<img class="rounded" src="./assets/image/professional_user2.jpg" alt="">
							</div>
							<div class="team-desc">
								<h4 class="team-name">Dalbir Singh Vilkhu</h4>
								<span class="team-position">Founder & Chief Sales Officer</span>
								<p>A highly accomplished visionary leader (Backed by almost three decades of experience
									in health-care industry) with recognised management skills and expertise in
									conceptualizing and developing a start-up from scratch to a highly successful and
									consistently profit making company.</p>
								<ul class="social-icons light si-colored-bg-on-hover no-pb">
									<li class="social-icons-item social-linkedin"><a class="social-icons-link"
											href="https://www.linkedin.com/in/dalbir-vilkhu/" target="_blank"><i
												class="fa fa-linkedin"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
					<!-- Team item -->
					<div class="item">
						<div class="team-item">
							<div class="team-avatar">
								<img class="rounded" src="./assets/image/professional_user3.jpg" alt="">
							</div>
							<div class="team-desc">
								<h4 class="team-name">Madhumita Mund Rao</h4>
								<span class="team-position">Chief Innovation Officer</span>
								<p>UK Tech Visa Holder and Accomplished Data and Technology Leader with 20+ years of
									experience in product lifecycle management, performing and leading geospatial data
									development, spatial data science, analysis, product & platform development for
									location intelligence solutions.</p>
								<ul class="social-icons light si-colored-bg-on-hover no-pb">
									<li class="social-icons-item social-linkedin"><a class="social-icons-link"
											href="https://www.linkedin.com/in/madhumitamundraodata/" target="_blank"><i
												class="fa fa-linkedin"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="team-item">
							<div class="team-avatar">
								<img class="rounded" src="./assets/image/professional_user4.jpg" alt="">
							</div>
							<div class="team-desc">
								<h4 class="team-name">Ashley Luders</h4>
								<span class="team-position">Chief Strategy Officer</span>
								<p>MedTech entrepreneur with both technology and medical industry experience. Founder of
									US based Santé Sonoma and Massive Health start-ups.</p>
								<ul class="social-icons light si-colored-bg-on-hover no-pb">
									<li class="social-icons-item social-linkedin"><a class="social-icons-link"
											href="https://www.linkedin.com/in/ashley-luders-7253a0188/"
											target="_blank"><i class="fa fa-linkedin"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- row end -->
		</div>
	</div>
</section>
<!-- =======================
	team grid -->

<!-- =======================
	blog -->
<section class="blog bg-light">
	<div class="container">
		<div class="row">
			<div class="col-12 col-lg-8 mx-auto">
				<div class="title text-center">
					<h2>Read our News, Comments & Thoughts</h2>
					<p>DataPitcher not only provides marketplace but also provides end-to-end solutioning to expediate
						research & innovations.</p>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<div class="owl-carousel arrow-dark arrow-hover" data-dots="false" data-items-xl="3" data-items-lg="3"
					data-items-md="2" data-items-sm="2" data-items-xs="1" data-autoplay="4500">
					<!-- post -->
					<div class="item">
						<div class="post">
							<img src="./assets/image/slider_1.jpg" alt="">
							<div class="post-info">
								<span class="post-tag bg-grad text-white mb-3 clearfix"><a
										href="http://www.mlcloudstudio.com/" target="_blank">Trend</a></span>
								<div class="post-author"><a href="https://www.linkedin.com/in/madhumitamundraodata/"
										target="_blank">By Madhumita Rao</a></div>
								<a class="post-title" href="http://www.mlcloudstudio.com/" target="_blank">UK Based
									Data/ML Products/Services</a>
								<p class="mb-0">Solve your business use-case with next-gen AI/ML</p>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="post">
							<img src="./assets/image/slider_2.jpg" alt="">
							<div class="post-info">
								<span class="post-tag bg-grad text-white mb-3 clearfix"><a
										href="http://www.datapitcher.io/" target="_blank">Healthcare</a></span>
								<div class="post-author"><a href="https://www.linkedin.com/in/ashley-luders-7253a0188/"
										target="_blank">By Ashley Luders</a></div>
								<a class="post-title" href="http://www.datapitcher.io/" target="_blank">AI Powered
									Medical Imaging </a>
								<p class="mb-0">HIPAA Compliant Healthcare Data and FHIR resources</p>
							</div>
						</div>
					</div>
					<!-- post -->
					<div class="item">
						<div class="post">
							<img src="./assets/image/slider_3.jpg" alt="">
							<div class="post-info">
								<span class="post-tag bg-grad text-white mb-3 clearfix"><a
										href="http://www.coursehive.co.in/" target="_blank">Education</a></span>
								<div class="post-author"><a href="https://www.linkedin.com/in/gauravright85/"
										target="_blank">By Gaurav Gupta</a></div>
								<a class="post-title" href="http://www.coursehive.co.in/" target="_blank">Learn Data
									Compliances & ML</a>
								<p class="mb-0">Premium Courses at freemium prices to expediate your learning around Big
									Data.</p>
							</div>
						</div>
					</div>
					<!-- post -->
					<div class="item">
						<div class="post">
							<img src="./assets/image/slider_4.jpg" alt="">
							<div class="post-info">
								<span class="post-tag bg-grad text-white mb-3 clearfix"><a href="#!">Idea</a></span>
								<div class="post-author"><a href="https://www.linkedin.com/in/dalbir-vilkhu/"
										target="_blank">By Dalbir Singh Vilkhu</a></div>
								<a class="post-title"
									href="https://www.youtube.com/watch?v=BGc-kh6nClE&feature=youtu.be"
									target="_blank">Birth of DataPitcher</a>
								<p class="mb-0">Reimaging Data Chemistry to create data-driven solutions.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	blog -->

<!-- =======================
	careers -->
<section class="pb-2">
	<div class="container">
		<div class="row">
			<!-- accordion gradient -->
			<div class="col-md-8 mb-5">
				<div class="accordion mb-0 accordion-grad" id="accordion3">
					<!-- item -->
					<div class="accordion-item">
						<div class="accordion-title">
							<a class="h6 mb-0" data-toggle="collapse" href="#collapse-7">How many free samples can i
								redeem?</a>
						</div>
						<div class="collapse show" id="collapse-7" data-parent="#accordion3">
							<div class="accordion-content">
								<p>Due to the limited quantity, each member's account is only entitled to 1 unique free
									sample. You can check out up to 4 free samples in each checkout. We take such
									matters very seriously and will look into individual cases thoroughly. </p>
								<p class="mb-0">We provide digital transformation solutions, enabling companies to make
									their visions reality. With us at your side, you will find the IT solution to
									achieve your strategic and financial goals.</p>
							</div>
						</div>
					</div>
					<!-- item -->
					<div class="accordion-item">
						<div class="accordion-title">
							<a class="h6 mb-0 collapsed" data-toggle="collapse" href="#collapse-8">What are the payment
								methods available?</a>
						</div>
						<div class="collapse" id="collapse-8" data-parent="#accordion3">
							<div class="accordion-content"> At the moment, we only accept Credit/Debit cards and Paypal
								payments. Paypal is the easiest way to make payments online. While checking out your
								order. Be sure to fill in correct details for fast & hassle-free payment processing. A
								thing that looks beautiful and attractive always grabs eyeballs. The real challenge
								before companies in today's world is to make their products and services appealing to
								everyone. It can be the packaging of an item or the design of its website and
								Applications. </div>
						</div>
					</div>
					<!-- item -->
					<div class="accordion-item">
						<div class="accordion-title">
							<a class="h6 mb-0 collapsed" data-toggle="collapse" href="#collapse-9">Can i pay without a
								paypal account?</a>
						</div>
						<div class="collapse" id="collapse-9" data-parent="#accordion3">
							<div class="accordion-content"> Yes! It is commonly misunderstood that a Paypal account is
								needed in order to make payments through Paypal. The truth is you DO NOT need one,
								although we strongly recommend you sign up to enjoy the added ease of use. </div>
						</div>
					</div>

					<!-- item -->
					<div class="accordion-item">
						<div class="accordion-title">
							<a class="h6 mb-0 collapsed" data-toggle="collapse" href="#collapse-10">How does the 30-day
								free trial work?</a>
						</div>
						<div class="collapse" id="collapse-10" data-parent="#accordion3">
							<div class="accordion-content">Go ahead, kick the tires. You have full access to all the
								features of wizixo Standard for 30 days. After 30 days you will need to provide a credit
								card to continue using the Standard features.</div>
						</div>
					</div>

					<!-- item -->
					<div class="accordion-item">
						<div class="accordion-title">
							<a class="h6 mb-0 collapsed" data-toggle="collapse" href="#collapse-11">What should I do if
								I miss my delivery?</a>
						</div>
						<div class="collapse" id="collapse-11" data-parent="#accordion3">
							<div class="accordion-content">We make 3 attempts on 3 continuing business days. In case you
								miss the delivery, give us a call on (251) 854-6308 or contact us at help@wizixo.com
							</div>
						</div>
					</div>
					<!-- item -->
					<div class="accordion-item">
						<div class="accordion-title">
							<a class="h6 mb-0 collapsed" data-toggle="collapse" href="#collapse-12">How can I get a
								refund in case I cancel my plan?</a>
						</div>
						<div class="collapse" id="collapse-12" data-parent="#accordion3">
							<div class="accordion-content"> The refund is provided as per with our cancellation policy.
								The refund can be credited to the source of payment (Example: debit card, credit card,
								net banking).</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Sidebar -->
			<div class="col-md-4 sidebar">
				<div class="widget bg-light p-3 border-0 border-radius-3">
					<h4>Have any question? </h4>
					<p>If you have any custom data or research request, please write to us at <a class="text-primary"
							href="mailto:contact@example.com">info@datapitcher.com</a> for more information.</p> or call
					us <a class="display-8 text-dark primary-hover" href="#">+919818787752</a>
				</div>
				<div class="widget border-0">
					<div class="fit-video">
						<iframe width="560" height="415" src="https://www.youtube.com/embed/o5G73Tgk_TA"
							allow="autoplay; encrypted-media" allowfullscreen></iframe>
					</div>
				</div>
			</div>
			<!-- Sidebar end-->

		</div>
	</div>
</section>
<!-- =======================
	careers -->

<!-- =======================
	call to action-->
<section class="p5-4">
	<div class="container">
		<div class="d-block d-md-flex bg-grad p-4 p-sm-5 all-text-white border-radius-3 pattern-overlay-3">
			<div class="align-self-center text-center text-md-left">
				<h3>Our leadership team has extensive experience in healthcare domain ranging from Data Sourcing,
					Machine Learning etc.</h3>
				<p class="m-0">Browse through thousands of compliant artifacts i.e. CT-Scans, X-rays or submit your
					custom request.</p>
			</div>
			<div class="mt-3 mt-md-0 text-center text-md-right ml-md-auto align-self-center">
				<a href="http://www.datapitcher.io/" target="_blank" class="btn btn-white mb-0">Explore Healthcare!!</a>
			</div>
		</div>
	</div>
</section>
<!-- =======================
	call to action-->

<!-- =======================
	footer  -->
<footer class="footer footer-dark section-pt position-relative pt-4 mt-5">
	<div class="position-absolute top-0 left-0 w-100">
		<svg width="100%" height="70" viewBox="0 0 500 70" preserveAspectRatio="none" style="margin-top: -70px">
			<path d="M0,70 L0,40 Q250,-40 500,40 L580,70 Z" fill="#343a40" />
		</svg>
	</div>
	<div class="footer-content pb-3">
		<div class="container">
			<div class="row">
				<!-- Footer widget 1 -->
				<div class="col-md-4">
					<div class="widget">
						<a href="index.html" class="footer-logo mb-3 d-block">
							<!-- SVG Logo Start -->
							<img src="./assets/image/logo/dp_logo.png">
							<!-- SVG Logo End -->
						</a>
						<p class="mt-3">A simple concept of creating open marketplace to provide every individual,
							enterprise, non-profit organizations & research companies a platform to monetize & exchange
							data in a regulated economy.</p>
					</div>
				</div>
				<!-- Footer widget 2 -->
				<div class="col-md-3 col-sm-6">
					<div class="widget address"
						style="background-image: url('./assets/image/landing/world-map.png'); background-position: 50% 20px; background-repeat: no-repeat; background-size: contain;">
						<ul class="list-unstyled">
							<li class="media mb-3"><i class="mr-3 display-8 ti-map-alt"></i>TBDC, 1 Yonge Street, Suite
								900 Toronto, ON M5E 1E5. </li>
							<li class="media mb-3"><i class="mr-3 display-8 ti-headphone-alt"></i>+919818787752</li>
							<li class="media mb-3"><i class="mr-3 display-8 ti-email"></i> info@datapitcher.com</li>
							<li class="media mb-3"><i class="mr-3 display-8 ti-time"></i>
								<p>Mon - Fri: <strong>09:00 - 21:00</strong> <br>Sat & Sun: <strong>Closed</strong></p>
							</li>
						</ul>
					</div>
				</div>
				<!-- Footer widget 3 -->
				<div class="col-md-2 col-sm-6">
					<div class="widget">
						<h6>Quick LInks</h6>
						<ul class="nav flex-column primary-hover">
							<li class="nav-item"><a class="nav-link" href="index.html">Home</a></li>
							<li class="nav-item"><a class="nav-link" href="portfolio-grid-column-4.html">Portfolio</a>
							</li>
						</ul>
					</div>
				</div>
				<!-- Footer widget 4 -->
				<div class="col-md-3">
					<div class="widget bg-grad p-4 all-text-white border-radius-3">
						<i class="ti-email newsletter-icon"></i>
						<p class="mb-2 text-white">Subscribe to our newsletter to receive latest news.</p>
						<div class="form-group mb-0">
							<input class="form-control border-white mb-3" type="email" placeholder="Enter email...">
							<button class="btn btn-dark mb-0">Join us</button>
						</div>
					</div>
				</div>
			</div>
			<!-- Footer widget 4 -->
		</div>
	</div>
	<div class="divider mt-3"></div>
	<!--footer copyright -->
	<div class="footer-copyright py-3">
		<div class="container">
			<div class="d-md-flex justify-content-between align-items-center py-3 text-center text-md-left">
				<!-- copyright text -->
				<div class="copyright-text">©2020 All Rights Reserved by <a href="#!"> DataPitcher.</a></div>
				<!-- copyright links-->
				<div class="copyright-links mt-3 mt-md-0">
					<ul class="list-inline">
						<li class="list-inline-item pl-2"><a class="list-group-item-action" href="#">Home</a></li>
						<li class="list-inline-item pl-2"><a class="list-group-item-action" href="#">Privacy Policy</a>
						</li>
						<li class="list-inline-item pl-2"><a class="list-group-item-action pr-0" href="#">Use of
								terms</a></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</footer>
<!-- =======================
	footer  -->

<div> <a href="#" class="back-top btn btn-grad"><i class="ti-angle-up"></i></a> </div>